import React from 'react';
import { CTASection } from '../components/CTASection';
export function About() {
  return <div className="flex flex-col w-full" data-id="element-408">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-409">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-410">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-411">
            About Wear Haus Designs
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-412">
            Stitching creativity into the fabric of Michiana since 1992
          </p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-20 bg-white" data-id="element-413">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-414">
          <div className="max-w-4xl mx-auto" data-id="element-415">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center" data-id="element-416">
              Our Story
            </h2>

            <div className="prose prose-lg max-w-none text-gray-700 space-y-6" data-id="element-417">
              <p data-id="element-418">
                Since 1992, Wear Haus Designs has been stitching creativity into
                the very fabric of Michiana and beyond. What started as a
                passion to provide local Schools, Businesses, and Organizations
                with custom embroidery has grown into something far greater.
                Though we've evolved over the years, one thing remains the
                same—our commitment to delivering quality products at
                competitive prices while staying deeply connected to the
                community.
              </p>

              <p data-id="element-419">
                At Wear Haus Designs, we know not all textile decorators are
                created equal, and neither are the custom pieces they produce.
                That's why we strive to innovate, using only the finest threads,
                premium inks, and top-tier artistry to create apparel and
                merchandise that consistently impress.
              </p>

              <p data-id="element-420">
                Our designs have made quite a splash with noteworthy projects,
                from Suicide/Overdose Prevention Campaigns and Walk-A-Thons to
                collaborations with National Championship Colleges and the
                iconic Netflix hit,{' '}
                <span className="font-semibold text-wh-pink" data-id="element-421">
                  Stranger Things
                </span>
                ! No matter where your creativity leads, we're here to ensure
                you make a lasting impression. With over 9 million embroidered
                pieces and just as many screen-printed creations to our name,
                we're ready to bring your ideas to life in spectacular fashion!
              </p>

              <p className="text-xl font-semibold text-wh-teal" data-id="element-422">
                We don't just create products; "We Logo YOUR Life" with designs
                that stand out and tell your unique story. This is who we
                are—dedicated to blending creativity, craftsmanship, and
                community in everything we do.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Amy Miller Section */}
      <section className="py-20 bg-gray-50" data-id="element-423">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-424">
          <div className="max-w-6xl mx-auto" data-id="element-425">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-426">
              Meet Amy Jo Miller
              <span className="block text-xl text-wh-pink font-semibold mt-2" data-id="element-427">
                Owner, CEO & Creative Force
              </span>
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-428">
              <div data-id="element-429">
                <img src="https://cdn.magicpatterns.com/uploads/2vM1EUA3BrHw3tJ2VQCFeh/Amy-Miller.webp" alt="Amy Jo Miller, Owner of Wear Haus Designs" className="rounded-2xl shadow-2xl w-full" data-id="element-430" />
              </div>

              <div className="prose prose-lg max-w-none text-gray-700 space-y-6" data-id="element-431">
                <p data-id="element-432">
                  Meet Amy Jo Miller – Owner, CEO, and the creative force behind
                  Wear Haus Designs! With over 12 years of Industry experience
                  and a lifetime of artistic flair, Amy has mastered the art of
                  making YOU shine. Her passion for creativity and commitment to
                  quality has fueled her journey from a self-taught Artisan to
                  the proud Owner of a thriving Business. Whether it's textile
                  laser embroidery, screen printing, or wide-format printing,
                  Amy brings a sprinkle of magic to everything she touches.
                </p>

                <p data-id="element-433">
                  Amy's guiding principle?{' '}
                  <span className="font-semibold text-wh-teal" data-id="element-434">
                    "Quality means exceeding expectations through continuous
                    improvement."
                  </span>{' '}
                  And it shows in every stitch and print. Alongside this, Wear
                  Haus Designs proudly lives by its slogan:{' '}
                  <span className="font-semibold text-wh-pink" data-id="element-435">
                    "We Logo Your Life"
                  </span>{' '}
                  – because Amy knows that every design tells a story. One of
                  her proudest career moments? Securing a contract for the
                  Netflix Original Series, Stranger Things, Amy made her
                  creative mark on one of the biggest stages in entertainment.
                </p>

                <p data-id="element-436">
                  When she's not busy turning ideas into reality, Amy embraces
                  her role as a devoted wife, mom to three, and a loving
                  fur-mom, now adding chickens and a rooster to the family! A
                  proud member of the Lion's Club of Middlebury, Indiana, Amy is
                  deeply rooted in her community. In her rare free time, she
                  loves being outdoors, soaking in nature, or working on her
                  next brilliant creation (because let's be honest, her
                  creativity never stops!).
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-br from-wh-pink to-pink-600" data-id="element-437">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-438">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-439">
            <div className="text-white" data-id="element-440">
              <div className="text-5xl font-bold mb-2" data-id="element-441">9M+</div>
              <div className="text-xl text-white/90" data-id="element-442">Embroidered Pieces</div>
            </div>
            <div className="text-white" data-id="element-443">
              <div className="text-5xl font-bold mb-2" data-id="element-444">9M+</div>
              <div className="text-xl text-white/90" data-id="element-445">
                Screen Printed Creations
              </div>
            </div>
            <div className="text-white" data-id="element-446">
              <div className="text-5xl font-bold mb-2" data-id="element-447">30+</div>
              <div className="text-xl text-white/90" data-id="element-448">Years in Business</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection data-id="element-449" />
    </div>;
}